import "../styles/Footer.css";
import React from "react";
import { version } from '../../package.json';

class Footer extends React.Component {
    render() {
        return (
            <footer className="main-footer">
                <div className="d-flex justify-content-between">
                    <div><strong>Copyright © {(new Date().getFullYear())} <a href="https://groszek.pl">U.I. INFO-SYSTEM sp.j.</a></strong> All rights reserved.</div>
                    <div><b>Wersja</b> {version}</div>
                </div>

            </footer>
        )
    }
}

export default Footer